<div class="full-height-flex">
  <adm4-inventory-header [currentInventory]='currentInventory$ | async'
    [inventories]="inventories$ | async"
    [inventoryValidationStatus]='inventoryValidationStatus$ | async'
  [readOnly]="isCurrentInventoryReadonly$ | async"></adm4-inventory-header>
  @if (currentInventory$ | async) {
    <div class='remaining-space-flex-content-wrapper'>
      <div class='remaining-space-flex-content details-container'>
        <div class='full-height-flex'>
          <div class='section-title border-0'>
            Deployment History
          </div>
          <div class='remaining-space-flex-content-wrapper'>
            <div class='remaining-space-flex-content'>
              @if (inventoryDeploymentHistory$ | async) {
                @if (hasHistory(inventoryDeploymentHistory$ | async)) {
                  <adm4-inventory-deployment-history-table
                    [inventoryDeploymentHistory]='inventoryDeploymentHistory$ | async'
                    [currentInventory]='currentInventory$ | async'
                    [displayedColumns]='displayedColumns | async'
                    (redeployDeployment)='redeployDeployment($event)'
                  ></adm4-inventory-deployment-history-table>
                } @else {
                  This inventory has no history yet, since nothing was deployed into it.
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
